import { render, staticRenderFns } from "./UninstallCodeManagement.vue?vue&type=template&id=58ea2152&"
import script from "./UninstallCodeManagement.vue?vue&type=script&lang=js&"
export * from "./UninstallCodeManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports